import { useStyle } from "./style";
import { useIntl } from "react-intl";
import { Text } from "@fluentui/react-components";
import { NoInteractionIconWithLogo } from "@/common/icons/noInteractionIconWithLogo/NoInteractionIconWithLogo";

export const NoInteractionPanel = () => {
	const style = useStyle();
	const intl = useIntl();

	return (
		<div className={style.noInteractionContainer}>
			<div className={style.iconContainer}>
				<div className={style.component}></div>
				<div className={style.iconElement}>
					<NoInteractionIconWithLogo sideSize={400} />
				</div>
			</div>
			<Text weight="bold" size={600} className={style.boldText}>
				{intl.formatMessage({ id: "Interaction.Contents.NoInteraction" })}
			</Text>
			<Text size={600} className={style.regularText}>
				{intl.formatMessage({ id: "Interaction.Contents.StartInteraction" })}
			</Text>
		</div>
	);
};
